import React, { useState, useEffect } from 'react';
import './AIAnimation.css';

const AIAnimation = ({onComplete}) => {
  const [currentAnimation, setCurrentAnimation] = useState(0);
  const [datasets, setDatasets] = useState([]);
  const [showClose, setShowClose] = useState(false);


  const animations = [
    {
      title: 'Generic AI',
      datasets: ['Travel', 'Sport', 'Social Media', 'Conversations', 'Generic'],
      isFirst: true
    },
    {
      title: 'CHORD A',
      datasets: ['Sensors', 'Edge technology', 'Connectivity', 'Data visualization', 'Software'],
      isFirst: false
    }
  ];

  useEffect(() => {
    // Reset stato
    setDatasets([]);
    setShowClose(false);

    const currentData = animations[currentAnimation];
    
    // Timings per aggiungere i dataset
    const timings = [
      { delay: 500, index: 0 },
      { delay: 1500, index: 1 },
      { delay: 2500, index: 2 },
      { delay: 3500, index: 3 },
      { delay: 4500, index: 4 },
      { delay: 5500, index: -1 }
    ];

    const timeouts = timings.map(({ delay, index }) => 
      setTimeout(() => {
        if (index === -1) {
          setShowClose(true);
        } else {
          setDatasets(prev => [...prev, currentData.datasets[index]]);
        }
      }, delay)
    );

 const switchTimeout = setTimeout(() => {
  if (currentAnimation < animations.length - 1) {
    // non è l'ultima → vai alla prossima sub-animazione
    setCurrentAnimation((prev) => prev + 1);
  } else {
    // è l'ultima → avvisa il parent
    onComplete && onComplete();
  }
}, 7000);

    return () => {
      timeouts.forEach(clearTimeout);
      clearTimeout(switchTimeout);
    };
  }, [currentAnimation]); 

  const currentData = animations[currentAnimation];

  return (
    <div className="ai-animation-container">
      <div className="ai-card">
        <div className="ai-header">
          <span className="ai-icon">✦</span>
          <span className="ai-title">{currentData.title}</span>
          <span className="ai-badge">AI AGENT</span>
        </div>
        
        <div className="datasets-container">
          {datasets.map((dataset, index) => (
            <div key={`${currentAnimation}-${index}`} className="dataset-item">
              <span className="dataset-name">{dataset}</span>
              <span className="dataset-label">Dataset</span>
            </div>
          ))}
        </div>
      </div>
      
     {showClose && (
  <button
    className={
      currentData.isFirst
        ? "close-button"
        : "close-button-completed"
    }
  >
    {currentData.isFirst ? "✕" : "✓"}
  </button>
)}
    </div>
  );
};

export default AIAnimation;